export enum SearchType {
  LIKE = '#like',
  OR = '#or',
  AND = '#and',
  EQUAL = '#equal',
  NOT = '#not',
}
